"use client";

import { LazyRetrievalQueriesDownloadModal } from "@faire/retailer-visitor-shared/features/RetrievalQueries/LazyRetrievalQueriesDownloadModal";
import { RetrievalQueriesButton } from "@faire/retailer-visitor-shared/features/RetrievalQueries/RetrievalQueriesButton";
import { getSettingShouldDisplayRetrievalModal } from "@faire/retailer-visitor-shared/settings/getSettingShouldDisplayRetrievalModal";
import { Storage } from "@faire/web/common/Storage";
import { IRetrievalQuery } from "@faire/web-api--source/indigofair/data/IRetrievalQuery";
import { Suspense } from "react";
import { useState } from "react";
import * as React from "react";

interface IProps {
  allRetrievalQueries: IRetrievalQuery[] | undefined;
  requestId: string | undefined;
}

export const RETRIEVAL_QUERY_KEY = "retrieval_queries";

export const RetrievalQueries: React.FC<IProps> = ({
  allRetrievalQueries,
  requestId,
}) => {
  const [isRetrievalModalOpen, setIsRetrievalModalOpen] = useState(false);

  if (
    getSettingShouldDisplayRetrievalModal() &&
    allRetrievalQueries?.length &&
    requestId
  ) {
    return (
      <>
        <RetrievalQueriesButton
          onClick={() => {
            setIsRetrievalModalOpen(true);
          }}
        />
        {isRetrievalModalOpen ? (
          <Suspense fallback={null}>
            <LazyRetrievalQueriesDownloadModal
              retrievalQueries={allRetrievalQueries}
              requestId={requestId}
              onClose={() => {
                setIsRetrievalModalOpen(false);
                Storage.local.removeItem(RETRIEVAL_QUERY_KEY);
              }}
            />
          </Suspense>
        ) : null}
      </>
    );
  } else {
    return null;
  }
};
